/*
###################################################################
Fitinsur Open Insurance - Copyright 2019-2023 - All Rights Reserved
###################################################################
*/

import { AccessNavigation } from "./AccessNavigation";
//import { ProductPlansNavigation } from "./ProductPlansNavigation";
import { ProductNavigation } from "./ProductNavigation";
import Colors from '../../../constants/Colors';

export default function Navigation({ permissions, match, ...props }) {
    return (
        <div style={{ display: "flex", gap: "20px" }}>
            <div style={{ display: "flex", flexWrap: "wrap", gap: "1rem", border: `solid 0.5px ${Colors.GRAY[3]}`, padding: "20px", marginBottom: "20px", borderRadius: "20px" }}>
                {AccessNavigation({ permissions, match, ...props })}
                {/* ProductPlansNavigation({ permissions, match, ...props }) */}
            </div>

            <div style={{ display: "flex", flexWrap: "wrap", gap: "1rem", border: `solid 0.5px ${Colors.GRAY[3]}`, padding: "20px", marginBottom: "20px", borderRadius: "20px", height: "fit-content" }}>
                {ProductNavigation({ permissions, match, ...props })}
            </div>
        </div>
    );
};